import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@repo/ui/card'
import { useT } from '@repo/ui/hooks'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@repo/ui/tabs'

import { Display } from '@/components/admin/structure-data/display/Display'
import { Schema } from '@/components/admin/structure-data/schema/Schema'
import { Organization } from '@/store/user'

export function StructuredDataRoute({ organization }: { organization: Organization }) {
  const { t, tc } = useT({ keyPrefix: 'admin.structuredData' })
  return (
    <Card className="flex flex-1 flex-col overflow-hidden overflow-y-auto">
      <CardHeader>
        <CardTitle>{tc('structuredDataSchema', { cfl: true })}</CardTitle>
        <CardDescription>{t('description')}</CardDescription>
      </CardHeader>

      <CardContent>
        <Tabs defaultValue="schema" className="relative">
          <TabsList>
            <TabsTrigger value="schema">
              {tc('item', { count: organization.structuredDataSchema.length })}
            </TabsTrigger>
            <TabsTrigger value="display">{tc('display', { cfl: true })}</TabsTrigger>
          </TabsList>

          <TabsContent value="schema">
            <Schema initialSchema={organization.structuredDataSchema} />
          </TabsContent>

          <TabsContent value="display">
            <Display
              initialDisplay={organization.structuredDataDisplay}
              initialSchema={organization.structuredDataSchema}
            />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  )
}
